import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { purgeWorkspaceFolders } from '../../../api/workspaces/folders/purgeWorkspaceFolders';

export function usePurgeWorkspaceFolders() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: purgeWorkspaceFolders,
    onSettled: (_data, _error, { workspaceId }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.allFolders(workspaceId)
      );
    },
  });
}
